import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb7f4678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modifier-header" }
const _hoisted_2 = { class: "alt" }
const _hoisted_3 = { class: "item-containers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductItem = _resolveComponent("ProductItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.modifier.ModifierName), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.getModifierRequirementText(_ctx.modifier)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modifier?.ItemList, (item) => {
        return (_openBlock(), _createBlock(_component_ProductItem, {
          key: item.ItemId,
          ref_for: true,
          ref: (el) => _ctx.context.childItems.push(el),
          item: item,
          modifier: _ctx.modifier,
          onItemExpanded: _ctx.itemExpanded
        }, null, 8, ["item", "modifier", "onItemExpanded"]))
      }), 128))
    ])
  ], 64))
}